import { render, staticRenderFns } from "./ChatBlock.vue?vue&type=template&id=161be95e&"
import script from "./ChatBlock.vue?vue&type=script&lang=js&"
export * from "./ChatBlock.vue?vue&type=script&lang=js&"
import style0 from "./ChatBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports